/* Madee: il cliché del logo (una tantum) va una sola volta per ordine e solo se nel carrello
   c'è almeno un prodotto personalizzato dal configuratore. Sostituisce hulk-cart.js. */
(function () {
  /* Regola del cliché (una tantum per logo):
     - serve se nel carrello c'è almeno un prodotto personalizzato con un logo NON già pagato;
     - un logo è "già pagato" solo se verificato: riordino da un ordine con cliché (proprietà
       _madee_cliche_order presente tra gli ordini del cliente con login) o cliente con tag "cliche-attivo";
     - al massimo un cliché per ordine; se non serve, si toglie. */
  var busy = false;
  // due varianti del prodotto "Cliché per Stampa Logo": prezzo pieno e prezzo ridotto per ordini da €500
  // di prodotti (IVA esclusa, cliché escluso). Il carrello tiene sempre quella giusta.
  var CLICHE_ID = 63732596179274;        // Standard, €98
  var CLICHE_PROMO_ID = 63732596212042;  // Ordini da €500, €50
  var PROMO_THRESHOLD = 50000;           // centesimi
  function verified(item) {
    var mc = window.madeeCliche || {};
    if (mc.tag) return true;
    var ref = item.properties && item.properties._madee_cliche_order;
    return !!(ref && mc.orders && mc.orders.indexOf(ref) > -1);
  }
  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cliche = cart.items.filter(function (i) { return i.product_type === 'Cliché'; });
        var goods = cart.items.filter(function (i) { return i.product_type !== 'Cliché'; })
          .reduce(function (a, i) { return a + i.original_line_price; }, 0);
        var personalized = cart.items.filter(function (i) { return i.properties && i.properties._madee_job_id; });
        var needs = personalized.some(function (i) { return !verified(i); });
        var wantId = CLICHE_ID;
        // gia' a posto: un solo cliché, quantita' 1, variante giusta (o nessuno se non serve)
        if (!needs && !cliche.length) return;
        if (needs && cliche.length === 1 && cliche[0].quantity === 1 && cliche[0].variant_id === wantId) return;
        var updates = {};
        cliche.forEach(function (i) { updates[i.key] = 0; });
        var req = cliche.length
          ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
          : Promise.resolve();
        if (needs) {
          req = req.then(function () {
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: wantId, quantity: 1 }] }) });
          });
        }
        return req.then(function () {
          if (location.pathname === '/cart') { location.reload(); return; }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  document.addEventListener('cart:change', function () { setTimeout(check, 300); });
  // anche dopo aggiunte dal cross-sell (cart:refresh): la soglia dei €500 puo' cambiare
  var t = null;
  document.addEventListener('cart:refresh', function () { clearTimeout(t); t = setTimeout(check, 800); });
  if (document.readyState !== 'loading') check();
  else document.addEventListener('DOMContentLoaded', check);
})();

/* Madee: cross-sell nel carrello "con il tuo logo". Stesso logo (dal job del prodotto già
   personalizzato), stesso colore e stessa quantità. La generazione gira sul server in background:
   la richiesta è salvata nel browser e riprende su ogni pagina finché l'accessorio non è nel carrello. */
(function () {
  var PROXY = '/apps/madee-configurator';
  var KEY = 'madee_pending_upsells';
  function sid() {
    try {
      var s = sessionStorage.getItem('madee_sid');
      if (!s) { s = Math.random().toString(36).slice(2, 12); sessionStorage.setItem('madee_sid', s); }
      return s;
    } catch (e) { return ''; }
  }
  function track(name, product, data) {
    var body = JSON.stringify({ event: name, session: sid(), product: product || '', variant: '', mobile: window.innerWidth < 1000, data: data || {} });
    try { if (!(navigator.sendBeacon && navigator.sendBeacon(PROXY + '/event', new Blob([body], { type: 'application/json' })))) fetch(PROXY + '/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }); } catch (e) {}
    try { if (window.gtag) window.gtag('event', 'madee_' + name, Object.assign({ product: product }, data || {})); } catch (e) {}
    try { if (window.fbq) window.fbq('trackCustom', 'Madee_' + name, Object.assign({ product: product }, data || {})); } catch (e) {}
  }
  function nounFor(title) {
    var t = (title || '').toLowerCase();
    var list = ['tovaglietta', 'sottobicchiere', 'poggia posate', 'porta posate', 'porta menu', 'porta conto', 'porta tovaglioli', 'cestino'];
    for (var i = 0; i < list.length; i++) if (t.indexOf(list[i]) > -1) return list[i];
    return 'prodotto';
  }
  var PLURALS = { tovaglietta: 'tovagliette', sottobicchiere: 'sottobicchieri', cestino: 'cestini' };
  var abs = function (u) { return u && u.charAt(0) === '/' ? location.origin + u : (u || ''); };
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }

  // ---- card del carrello in attesa: l'intera card diventa un loader che spiega cosa succede ----
  function paintCards() {
    var pending = load();
    document.querySelectorAll('[data-madee-upsell]').forEach(function (btn) {
      var card = btn.closest('.madee-xsell, .horizontal-product');
      if (!card) return;
      var p = pending.find(function (x) { return String(x.variantId) === btn.dataset.variantId; });
      var ov = card.querySelector('.madee-upsell-loading');
      if (p && p.state !== 'failed') {
        card.classList.add('is-madee-loading');
        if (!ov) {
          ov = document.createElement('div');
          ov.className = 'madee-upsell-loading';
          card.appendChild(ov);
        }
        if (ov.dataset.noun !== p.noun) {
          ov.dataset.noun = p.noun;
          ov.innerHTML = '<span class="madee-upsell-loading__spinner" aria-hidden="true"></span>' +
            '<div><strong>Stiamo incidendo il tuo logo sul ' + p.noun + '</strong>' +
            '<span>Circa 20 secondi. Puoi chiudere il carrello e continuare: lo aggiungiamo appena pronto.</span></div>';
        }
      } else {
        if (card.classList.contains('is-madee-loading')) card.classList.remove('is-madee-loading');
        if (ov) ov.remove();
        if (p && p.state === 'failed' && btn.textContent !== 'Riprova') { btn.disabled = false; btn.textContent = 'Riprova'; }
      }
    });
  }

  function toast(text) {
    var t = document.createElement('div');
    t.className = 'madee-toast';
    t.setAttribute('role', 'status');
    t.textContent = text;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 400); }, 5000);
  }

  var polling = false;
  function poll() {
    var pending = load().filter(function (p) { return p.state !== 'failed' && p.job && p.job.indexOf('starting-') !== 0 && Date.now() - p.started < 5 * 60 * 1000; });
    save(load().filter(function (p) { return p.state === 'failed' ? Date.now() - p.started < 60 * 1000 : Date.now() - p.started < 5 * 60 * 1000; }));
    if (!pending.length || polling) { paintCards(); return; }
    polling = true;
    Promise.all(pending.map(function (p) {
      return fetch(PROXY + '/status/' + encodeURIComponent(p.job)).then(function (r) { return r.json(); }).then(function (st) {
        if (st.status === 'ready') return addToCart(p, st);
        if (st.status === 'failed' || (st.status === 'not_found' && Date.now() - p.started > 60 * 1000)) {
          var list = load(); list.forEach(function (x) { if (x.job === p.job) x.state = 'failed'; }); save(list);
          track('upsell_failed', p.noun, { reason: 'preview' });
        }
      }).catch(function () {});
    })).then(function () {
      polling = false;
      paintCards();
      if (load().some(function (p) { return p.state !== 'failed'; })) setTimeout(poll, 3000);
    });
  }

  function addToCart(p, st) {
    var props = {
      'Colore': p.color || '',
      'Logo personalizzato': p.logoName || '',
      '_madee_job_id': p.job,
      '_madee_preview_url': abs(st.preview_url)
    };
    if (st.logo_url) props['_madee_logo_url'] = abs(st.logo_url);
    if (st.detail_url) props['_madee_detail_url'] = abs(st.detail_url);
    if (p.clicheOrder) { props['_madee_cliche_order'] = p.clicheOrder; props['Cliché'] = 'già pagato (ordine ' + p.clicheOrder + ')'; }
    // rimuove subito dalla lista per non aggiungerlo due volte
    save(load().filter(function (x) { return x.job !== p.job; }));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(p.variantId), quantity: p.quantity, properties: props }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      track('upsell_added', p.noun, { quantity: p.quantity });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var drawerOpen = document.querySelector('cart-drawer[open]');
      if (!drawerOpen) toast((PLURALS[p.noun] || p.noun).replace(/^./, function (c) { return c.toUpperCase(); }) + ' con il tuo logo aggiunti al carrello.');
    }).catch(function () {
      var list = load(); list.push(Object.assign({}, p, { state: 'failed' })); save(list);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-madee-upsell]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var d = btn.dataset;
    var noun = nounFor(d.title);
    btn.disabled = true;
    track('upsell_click', noun);
    // se c'era un tentativo fallito per questa variante, lo sostituiamo
    save(load().filter(function (x) { return String(x.variantId) !== d.variantId; }));
    var form = new FormData();
    form.append('job_id', d.job);
    form.append('color', d.color || '');
    form.append('noun', noun);
    form.append('product_image_url', d.image || '');
    form.append('logo_reference', d.logoName || '');
    form.append('async', '1');
    var entry = { job: null, variantId: d.variantId, quantity: Math.max(1, parseInt(d.quantity, 10) || 1), color: d.color, noun: noun, logoName: d.logoName, clicheOrder: d.clicheOrder || '', started: Date.now() };
    // loader subito, prima ancora della risposta del server
    var list = load(); list.push(Object.assign({}, entry, { job: 'starting-' + Date.now() })); save(list); paintCards();
    fetch(PROXY + '/preview-from-job', { method: 'POST', body: form })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (res) {
        var l = load().filter(function (x) { return String(x.variantId) !== d.variantId; });
        if (!res.job_id) { l.push(Object.assign({}, entry, { job: 'x', state: 'failed' })); save(l); paintCards(); return; }
        l.push(Object.assign({}, entry, { job: res.job_id })); save(l);
        setTimeout(poll, 4000);
      })
      .catch(function () {
        var l = load().filter(function (x) { return String(x.variantId) !== d.variantId; });
        l.push(Object.assign({}, entry, { job: 'x', state: 'failed' })); save(l); paintCards();
      });
  }, true);

  // il carrello laterale si ridisegna a ogni modifica: riapplichiamo i loader
  document.addEventListener('cart:refresh', function () { setTimeout(paintCards, 600); });
  document.addEventListener('cart:change', function () { setTimeout(paintCards, 600); });
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled || !load().length) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; paintCards(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') poll(); else document.addEventListener('DOMContentLoaded', poll);
})();

/* Madee: nel carrello un clic sulla foto di un prodotto la ingrandisce */
(function () {
  function big(src) { return (src || '').replace(/([?&])width=\d+/, '$1width=1400'); }
  document.addEventListener('click', function (e) {
    var img = e.target && e.target.closest && e.target.closest('.line-item__media-wrapper img, img.line-item__media');
    if (!img) return;
    e.preventDefault();
    e.stopPropagation();
    var box = document.createElement('div');
    box.className = 'madee-lightbox';
    box.innerHTML = '<div class="madee-lightbox__inner"><img src="' + big(img.currentSrc || img.src) + '" alt="">' +
      '</div><button type="button" class="madee-lightbox__close" aria-label="Chiudi"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button>';
    box.addEventListener('click', function () { box.remove(); });
    document.addEventListener('keydown', function esc(ev) { if (ev.key === 'Escape') { box.remove(); document.removeEventListener('keydown', esc); } });
    document.body.appendChild(box);
  }, true);
})();

/* Madee: card del cross-sell nel carrello: colore e quantita' prima di aggiungere, "Aggiungi senza logo" */
(function () {
  function money(cents) { return '\u20ac' + (cents / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function state(card) {
    var sel = card.querySelector('[data-xsell-color]');
    var opt = sel ? sel.options[sel.selectedIndex] : null;
    var qtyEl = card.querySelector('[data-xsell-qty]');
    var qty = Math.max(1, parseInt(qtyEl.value, 10) || 1);
    return { opt: opt, qty: qty, qtyEl: qtyEl };
  }
  function sync(card) {
    var st = state(card);
    st.qtyEl.value = st.qty;
    var plain = card.querySelector('[data-xsell-plain]');
    var logo = card.querySelector('[data-madee-upsell]');
    var perso = card.querySelector('[data-xsell-personalize]');
    if (st.opt) {
      var price = parseInt(st.opt.dataset.price, 10) || 0;
      card.querySelector('[data-xsell-unit]').textContent = money(price);
      card.querySelector('[data-xsell-total]').textContent = money(price * st.qty);
      card.querySelector('[data-xsell-thumb]').src = st.opt.dataset.thumb;
      plain.dataset.variantId = st.opt.value;
      if (logo) { logo.dataset.variantId = st.opt.value; logo.dataset.color = st.opt.dataset.color; logo.dataset.image = st.opt.dataset.image; }
      if (perso) perso.href = card.dataset.productUrl + '?variant=' + st.opt.value + '&madee_open=1';
    } else {
      var unit = card.querySelector('[data-xsell-unit]').textContent.replace(/[^\d,]/g, '').replace(',', '.');
      card.querySelector('[data-xsell-total]').textContent = money(Math.round(parseFloat(unit || '0') * 100) * st.qty);
    }
    if (logo) logo.dataset.quantity = st.qty;
  }
  document.addEventListener('change', function (e) {
    var card = e.target.closest && e.target.closest('[data-madee-xsell]');
    if (card && (e.target.matches('[data-xsell-color]') || e.target.matches('[data-xsell-qty]'))) sync(card);
  });
  document.addEventListener('input', function (e) {
    var card = e.target.closest && e.target.closest('[data-madee-xsell]');
    if (card && e.target.matches('[data-xsell-qty]') && e.target.value !== '') sync(card);
  });
  // capture: aggiorna quantita'/variante del bottone "+ Con il tuo logo" prima che parta il suo handler
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-xsell-step], [data-madee-upsell]');
    if (!t) return;
    var card = t.closest('[data-madee-xsell]');
    if (!card) return;
    if (t.matches('[data-xsell-step]')) {
      e.preventDefault();
      var q = card.querySelector('[data-xsell-qty]');
      q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(t.dataset.xsellStep, 10));
    }
    sync(card);
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-xsell-plain]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var card = btn.closest('[data-madee-xsell]');
    sync(card);
    var qty = state(card).qty;
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Aggiungo\u2026';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: qty }] }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        try { if (window.madeeTrack) window.madeeTrack('xsell_plain_added', { quantity: qty }); } catch (err) {}
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { btn.textContent = 'Riprova'; btn.disabled = false; return 'err'; })
      .then(function (r) { if (r !== 'err') setTimeout(function () { if (document.contains(btn)) { btn.disabled = false; btn.textContent = label; } }, 1500); });
  });
})();
